"use strict";
exports.__esModule = true;
exports.DEFAULT_LOCALE = exports.LOCALES = void 0;
exports.LOCALES = ['en-US', 'tr-TR', 'ru-RU', 'es-ES', 'de-DE', 'zh-HK', 'fr-FR', 'it-IT', 'pt-PT', 'pl-PL'];
exports.DEFAULT_LOCALE = 'en-US';
//# sourceMappingURL=locales.constant.js.map